import React, { FC, useEffect, useState } from "react";
import { createClickableLink } from "../../../../components/common/datatable/DataTableUtils";
import { useFindUserSettingsByGroupNameQuery } from "../../../../components/common/userSetting/userSettingsApi";
import { SearchInputWrapper } from "../../../../components/common/datatable/filter/SearchInputWrapper";
import { DataTable } from "../../../../components/common/datatable/DataTable";
import Breadcrumb from "../../../../components/common/Breadcrumbs";
import { useLazyExportAppraisalRollsDataQuery, useSearchAppraisalRollsQuery } from "../appraisalRollsApi";
import { DataTableColumn } from "../../../../components/common/datatable/DataTableTypes";
import CollectorSearchInputWrapper from "../../../../components/common/datatable/filter/CollectorSearchInputWrapper";

const AppraisalRoll: FC = () => {

    const [crumbs] = useState([
        { content: "Home", url: "/home" },
        { content: "Appraisal Rolls", url: "" }]
    )


    useEffect(() => {
        document.title = 'Appraisal Rolls';
    });

    const { data: userSettings } = useFindUserSettingsByGroupNameQuery("Appraisal Roll");
    const [triggerExportAppraisalRollsDataQuery] = useLazyExportAppraisalRollsDataQuery();

    const columns: DataTableColumn[] = [
        {
            label: "Tax Account No.",
            accessor: "taxAccountNumber",
            cell: (props: any) => {
                let path = "/appraisal-rolls/" + props.row.original.id;
                return createClickableLink(path, props.value, userSettings, false, "", ["APRROL-R", "APRROL-V"]);
            },
            filterOptions: [{
                filterComponent: <SearchInputWrapper type={"text"} placeholder={"Enter Tax Account No..."}
                    name={"taxAccountNumber"} accessor={"taxAccountNumber"} />,
                overrideFilterLabel: "Tax Account No.",
                overrideFilterAccessor: "taxAccountNumber"
            }]
        },

        {
            label: "Collector", accessor: "collectorId", visibility: { hasShowSetting: false },
            cell: (props: any) => {
                return (<span>{props.row.original.collectorName}</span>)
            },
            filterOptions: [{
                filterComponent: <CollectorSearchInputWrapper accessor="collectorId" />,
                overrideFilterAccessor: "collectorId",
                overrideFilterLabel: "Collector",
            }]
        },
        {
            label: "Tax Year", accessor: "taxYear",
            filterOptions: [{
                filterComponent: <SearchInputWrapper type={"number"} placeholder={"Enter Tax Year..."}
                    name={"taxYear"}
                    accessor={"taxYear"} />,
            }]
        },
        {
            label: "Situs Address", accessor: "situsAddress",
            filterOptions: [{
                filterComponent: <SearchInputWrapper type={"text"} placeholder={"Enter Situs Address..."}
                    name={"situsAddress"} accessor={"situsAddress"} />,
            }]
        },
        {
            label: "Owner", accessor: "ownerName",
            filterOptions: [{
                filterComponent: <SearchInputWrapper type={"text"} placeholder={"Enter Owner..."} name={"ownerName"}
                    accessor={"ownerName"} />,
            }]
        },
        {
            label: "Legal Description", accessor: "legalDescription",
            filterOptions: [{
                filterComponent: <SearchInputWrapper type={"text"} placeholder={"Enter Legal Description..."}
                    name={"legalDescription"} accessor={"legalDescription"} />,
            }]
        },
    ]

    return (

        <div className="user-container px-4 py-2">
            <div className="flex justify-between">
                <Breadcrumb crumbs={crumbs} />
            </div>
            <DataTable
                columns={columns}
                actions={{
                    fetchAction: useSearchAppraisalRollsQuery,
                    exportAction: triggerExportAppraisalRollsDataQuery
                }}
                userSettingGroup={"Appraisal Roll"}
                defaultFilter={{
                    sort: "collectorId",
                    sortOrder: "ASCENDING"
                }}
                defaultSortOptions={{
                    accessor: "collectorId",
                    direction: "asc"
                }}
                basePermission={"APRROL"}
                
            />

        </div>

    )
}
export default AppraisalRoll


